module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAYAAACaq43EAAAAyUlEQVRIx2M4J6j2fyAww6jFoxbTzOI/nz7fGQjM8H+AAMkWL7qzF6v4pXf3/x98fpk2Fp9+fev/kZdX///+++f/9Otb4eIg/tTrm/8nHu77339lPfUsBhl86vXN//57Gv9Purbxvx+Qzjw2BS6//N6B/xH7O8C498o66lkcdaALaGj7//Sjk/+nHZ0EtqDh/JL/O5+cBcvnHJ8GFgPRIDUPv7yi3OIPP7/8P/Liyv/Pv75RN3GFhoYeGAjMAAT/BwiPWjxqMW0wAE9scZE0GvmtAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/iq.png
// module id = 843
// module chunks = 0